import { render, staticRenderFns } from "./EditElementModal.vue?vue&type=template&id=3651efb4&"
import script from "./EditElementModal.vue?vue&type=script&lang=js&"
export * from "./EditElementModal.vue?vue&type=script&lang=js&"
import style0 from "./EditElementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports